/**
 * By default return a number between 1 to 2
 * If set numeric parameter bigger that 2 function return a number between 1 to parameter selected in random way
 *
 * @param {number} If parameter is smaller that 2 , default value is asigned
 * @returns {number} selected from range 1 to param (2 by default) in random way
 */

export function ramdomSelector(seed = 2) {
  seed = seed < 2 ? 2 : seed;
  const randomNum = Math.random();
  const NumSelected = Math.floor(randomNum * seed) + 1;
  return NumSelected;
}
